import styled from "styled-components";

export const StyledUnitScreen = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  min-height: 100vh;
  height: 100%;
  padding: 30px 30px 30px 30px;
  background-color: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text};
  gap: 6px;
  position: relative;
  padding-top: 420px;
  padding-bottom: 120px;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 72vh 30% 10% 30%;
  }

  h2 {
    color: ${({ theme }) => theme.colors.text};
    font-size: 24px;
    font-weight: 600;
    margin: 12px 0 4px 0;
  }

  h4 {
    color: ${({ theme }) => theme.colors.text};
    font-size: 16px;
    margin: 0px;
    font-weight: 600;
  }
  .outlined-btn {
    border: 1px solid ${({ theme }) => theme.colors.primary};
    background-color: transparent;
    color: ${({ theme }) => theme.colors.primary};
    font-size: 14px;
    font-weight: 600;
    margin: 24px 0;
  }
  .description {
    line-height: 22px;
    font-size: 14px;
    font-weight: 500;
  }
  .amenity-item {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
    .icon {
      font-size: 20px;
    }
    span {
      text-transform: capitalize;
      font-size: 14px;
    }
  }
  .tags-on-photo {
    display: flex;
    gap: 6px;
    position: absolute;
    z-index: 9;
    top: 360px;
    right: 20px;

    div {
      font-weight: 600;
    }
  }
  .go-back {
    cursor: pointer;
    position: absolute;
    z-index: 99;
    top: 20px;
    left: 20px;
    height: 36px;
    width: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.backgroundOpacity90};
    filter: ${({ theme }) =>
      theme.colors.background === "#171717" ? "invert(1)" : "invert(0)"};
    img {
      height: 20px;
    }
  }
`;

export const StyledMainImage = styled.img`
  height: 400px;
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  object-fit: cover;

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    height: 300px;
  }
`;

export const StyledTag = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 12px;
  background-color: ${({ theme }) => theme.colors.card};
  color: ${({ theme }) => theme.colors.text};
  padding: 4px 8px;
  border-radius: 10px;
  min-width: 40px;
  font-weight: 600;
  img {
    height: 16px;
    filter: ${({ theme }) =>
      theme.colors.background === "#171717" ? "invert(1)" : "invert(0)"};
  }
`;

export const StickyBottomBox = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: ${({ theme }) => theme.colors.background};
  padding: 20px;
  button {
    height: 50px;
    @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
      width: 40%;
      margin: auto;
    }
  }
`;

export const CalendarWrapper = styled.div`
  margin: 16px 0;

  .react-calendar {
    width: 100%;
    border: none;
    font-family: "Poppins", sans-serif;
    line-height: 2.5;
    background-color: transparent;
    color: ${({ theme }) => theme.colors.text};
    font-size: 12px;
    gap: 4px;
    abbr {
      text-decoration: none;
      text-transform: capitalize;
    }

    .react-calendar__navigation {
      display: flex;
      justify-content: space-between;
      margin-bottom: 8px;

      button {
        background: none;
        border: none;
        cursor: pointer;
        font-size: 14px;
        color: ${({ theme }) => theme.colors.text};
      }
    }

    .react-calendar__tile {
      border-radius: 4px;
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      &:hover {
        background-color: ${({ theme }) => theme.colors.card};
        color: ${({ theme }) => theme.colors.text};
      }
    }
    .react-calendar__tile--now {
      background: ${({ theme }) => theme.colors.card};
    }

    .react-calendar__tile--range {
      background: ${({ theme }) => theme.colors.button};
      color: ${({ theme }) => theme.colors.buttonFont};
      border-radius: 4px;
    }
    .react-calendar__month-view__days__day--weekend {
      color: ${({ theme }) => theme.colors.text};
    }
    .react-calendar__tile:disabled {
      color: #ababab;
    }
    .react-calendar__tile:hover {
      //outline: 1px solid;
      background-color: ${({ theme }) => theme.colors.button};
      color: ${({ theme }) => theme.colors.buttonFont};
    }
    .react-calendar__tile--range {
      background: ${({ theme }) => theme.colors.button};
      color: ${({ theme }) => theme.colors.buttonFont};
    }

    .react-calendar .available {
      background-color: #ffffff;
    }

    .react-calendar .unavailable {
      background-color: ${({ theme }) => theme.colors.background};
      color: #999;
      opacity: 0.3;
      cursor: not-allowed;
    }
    .react-calendar__tile.react-calendar__month-view__days__day.react-calendar__month-view__days__day.unavailable {
      background-color: ${({ theme }) => theme.colors.card};
      color: ${({ theme }) => theme.colors.text};
      opacity: 0.3;
    }
    .react-calendar .in-range {
      background-color: #e6f3ff;
    }

    .react-calendar .invalid-range {
      background-color: #ffe6e6;
    }

    .react-calendar__tile--range .available {
      background: ${({ theme }) => theme.colors.button};
      color: ${({ theme }) => theme.colors.buttonFont};
    }
  }
`;
